import { Vector3 } from "three"

export const defaults3d = {
    receiveShadow: true,
    castShadow: true
}
